import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import DownloadIcon from '@mui/icons-material/Download';
import Footer from '../navbar/Footer';
import {
  Container,
  Typography,
  Grid,
  Card,
  Divider,
  FormControl,
  InputLabel,
  Select,  
  MenuItem,
  styled,
  createTheme,
  ThemeProvider,
  Box,
  CardMedia,
  Button,
} from '@mui/material';
import moment from 'moment';
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; 
import { useNavigate } from 'react-router-dom'; 


const ihpiData = [
      {
      "title": "Indice harmonisé de la production industrielle définitif du premier trimestre 2025",
      "link": "/documents/IndicesIHPI/Rapport_IHPI_T1_definitif_2025_T1.pdf",
      "image": "assets/indicesIHPI/IHPI2024.PNG",
      "description": "Au premier trimestre 2025, la production industrielle enregistre un recul significatif de 11,7%, principalement tirée vers le bas par les secteurs de l'énergie (-9,7%) et de l'agroalimentaire (-10,3%) qui contribuent à eux seuls à plus de 80% de cette baisse.",
      "date": "2025-02-12"
  },
      {
      "title": "Indice harmonisé de la production industrielle définitif du premier trimestre 2024 et provisoire du deuxième trimestre 2024",
      "link": "/documents/IndicesIHPI/Rapport_IHPI_T1_T2_2024.pdf",
      "image": "assets/indicesIHPI/IHPI2024.PNG",
      "description": "La production globale de l’industrie s’est légèrement améliorée de 2,7% au premier trimestre 2024 en glissement annuel.",
      "date": "2024-09-12"
  },
    {
      "title": "Indice harmonisé de la production industrielle définitif du premier trimestre 2024 et provisoire du deuxième trimestre 2024",
      "link": "/documents/IndicesIHPI/Rapport_IHPI_T1_T2_2024.pdf",
      "image": "assets/indicesIHPI/IHPI2024.PNG",
      "description": "La production globale de l’industrie s’est légèrement améliorée de 2,7% au premier trimestre 2024 en glissement annuel.",
      "date": "2024-09-12"
  },
  {
      "title": "Indice harmonisé de la production industrielle définitif du quatrième trimestre 2023 et provisoire du premier trimestre 2024",
      "link": "/documents/IndicesIHPI/Rapport-IHPI-T4-definitif-2023-T1-provisoire-2024-_2_.pdf",
      "image": "assets/indicesIHPI/IHPI2024.PNG",
      "description": "Une augmentation de 10,4% par rapport au même trimestre de l'année 2022 et une augmentation légère de 2,7% au premier trimestre 2024 en glissement annuel.",
      "date": "2024-07-26"
  },
  {
      "title": "Indice harmonisé de la production industrielle définitif du troisième trimestre 2023",
      "link": "/documents/IndicesIHPI/Rapport-IHPI-T3-provisoire-2023-_2_.pdf",
      "image": "assets/indicesIHPI/IHPI2024.PNG",
     "description": "Une augmentation de 20,8% par rapport au même trimestre de l'année 2022 due à la bonne performance réalisée par presque toutes les branches du secteur industriel.",
      "date": "2023-12-20"
  },
  {
      "title": "Indice harmonisé de la production industrielle définitif du deuxième trimestre 2023",
      "link": "/documents/IndicesIHPI/Rapport-IHPI-T2-definitif-2023-vff-1.pdf",
      "image": "assets/indicesIHPI/IHPI2024.PNG",
       "description": "Une augmentation de 5,5% par rapport au même trimestre de l'année 2022 à l'intervention des industries alimentaires et de tabac et de l’industrie énergétique avec la production  respective de 4,9% et de 8,3%.",
      "date": "2023-08-01"
  },
  {
      "title": "Indice harmonisé de la production industrielle définitif du premier trimestre 2023",
      "link": "/documents/IndicesIHPI/Rapport-IHPI-T1-definitif-2023.pdf",
      "image": "assets/indicesIHPI/IHPI2024.PNG",
      "description": "Un recul de 11,5%  par rapport au même trimestre de l'année 2022 à l'intervention du mauvais comportement affiché par les industries alimentaires et de tabac dont la production a baissé de 11,5% avec une contribution positive de 12,9 points de pourcentage.",
      "date": "2023-06-14"
  },
  {
      "title": "Indice harmonisé de la production industrielle provisoire du troisième trimestre 2022",
      "link": "/documents/IndicesIHPI/Rapport-IHPI-T3-et-T4-definitif-2022-vf.pdf",
      "image": "assets/indicesIHPI/IHPI2024.PNG",
      "description": "Une augmentation de  8,6% par rapport au même trimestre de l'année 2021 à l'intervention des performances réalisées par les industries extractives avec 113,4%.",
      "date": "2022-02-25"
  },
  {
      "title": "Indice harmonisé de la production industrielle définitif du premier et du deuxième trimestre 2022",
      "link": "/documents/IndicesIHPI/Rapport-IHPI-T1-et-T2-definitif-2022vf.pdf",
      "image": "assets/indicesIHPI/IHPI2024.PNG",
      "description": "Un repli de 3,1 % par rapport au quatrième trimestre de l’année 2021 à l'intervention du mauvais comportement affiché par le secteur de l'activité des industries alimentaires et de tabac, celui des industries pétrolières, chimiques et plastiques ainsi que celui des industries du papier, carton et édition, imprimerie dont la production a chuté de 4,6% ; 9,6% et de 80,8%",
      "date": "2022-07-01"
  },
  {
      "title": "Indice harmonisé de la production industrielle définitif du troisième et du quatrième trimestre 2021",
      "link": "/documents/IndicesIHPI/Rapport-IHPI-T3-et-T4-Definitif-2021-VF.pdf",
      "image": "assets/indicesIHPI/IHPI2024.PNG",
      "description": "Une progression de 15,5 % de la production industrielle par rapport au trimestre précédent, avec des performances positives dans presque tous les secteurs, à l'exception des industries du papier, carton, et édition, qui ont enregistré un recul de 8,9 %.",
      "date": "2022-02-22"
  },
  {
      "title": "Indice harmonisé de la production industrielle définitif du deuxième trimestre et provisoire du troisième trimestre 2021",
      "link": "/documents/IndicesIHPI/Rapport-IHPI-T2-definitif-et-T3-provisoire-2021-_.pdf1_",
      "image": "assets/indicesIHPI/IHPI2024.PNG",
      "description": "Une amélioration de 7,5 % de la production, principalement soutenue par les industries alimentaires et de tabac (10,6 %), métalliques (61,5 %), énergétiques (3,4 %) et pétrolières, chimiques et plastiques (1,9 %).",
      "date": "2021-12-17"
  },
  {
      "title": "Indice harmonisé de la production industrielle définitif du premier trimestre et provisoire du deuxième trimestre 2021",
      "link": "/documents/IndicesIHPI/Rapport-IHPI-T1-definitif-et-T2-provisoire-2021.pdf",
      "image": "assets/indicesIHPI/IHPI2024.PNG",
      "description": "Une détérioration de 8,4 % de la production industrielle en variation trimestrielle, en grande partie à cause des performances négatives de la majorité des branches, notamment les industries alimentaires et de tabac (-8,1 %), énergétiques (-6,4 %), métalliques (-18,0 %), pétrolières, chimiques et plastiques (-14,4 %), et papier, carton et édition (-69,9 %). En glissement annuel, une légère hausse de 2,6 % est notée, principalement portée par les secteurs alimentaires et de tabac (+4,8 %) et métalliques (+28,7 %). Le deuxième trimestre 2021 affiche une amélioration de 6,7 % de la production, propulsée par les industries alimentaires et de tabac (+5,5 %), métalliques (+61,5 %), et pétrolières, chimiques et plastiques (+1,9 %), avec un accroissement de 6,0 % en glissement annuel.",
      "date": "2021-08-20"
  },
  {
      "title": "Indice harmonisé de la production industrielle provisoire du troisième trimestre 2020",
      "link": "/documents/IndicesIHPI/Rapport-IHPI-T3-provisoire-2020-vf.pdf",
      "image": "assets/indicesIHPI/IHPI2024.PNG",
      "description": "Une progression de 26,7 % de la production industrielle, principalement grâce à l'augmentation des secteurs alimentaires et de tabac (+31,3 %), métalliques (+73,4 %), pétrolières, chimiques et plastiques (+50,1 %), et autres industries de fabrication (+33,2 %). En glissement annuel, l'indice indique une hausse de 2,3 %, avec des contributions positives des secteurs alimentaires et de tabac (+1,8 %), pétrolières, chimiques et plastiques (+69,9 %), et métalliques (+4,5 %).",
      "date": "2020-11-30"
  },
  {
      "title": "Indice harmonisé de la production industrielle définitif du quatrième trimestre 2019 et provisoire du premier trimestre 2020",
      "link": "/documents/IndicesIHPI/Rapport-IHPI-T4-définitif-2019-et-T1-provisoire-2020-_2_.pdf",
      "image": "assets/indicesIHPI/IHPI2024.PNG",
      "description": "Un recul de 18,0 % de la production industrielle, attribué aux baisses dans les industries métalliques (-56,0 %), alimentaires et de tabac (-17,3 %), et énergétiques (-3,7 %). En glissement annuel, une légère augmentation de 4,1 % est constatée, notamment grâce à une hausse de 5,0 % dans le secteur alimentaire. Pour le premier trimestre 2020, une chute de 5,5 % est observée, motivée par des baisses dans presque toutes les branches, hormis les industries énergétiques qui ont augmenté de 3,3 %. Cependant, en glissement annuel, une progression positive de 5,2 % est constatée, portée par de bonnes performances dans plusieurs secteurs.",
      "date": "2020-07-15"
  },
  {
      "title": "Indice harmonisé de la production industrielle définitif du premier et du deuxième trimestre 2020",
      "link": "/documents/IndicesIHPI/Rapport-IHPI-T1-définitif-et-T2-provisoire-2020.pdf",
      "image": "assets/indicesIHPI/IHPI2024.PNG",
      "description": "Une baisse de 5,7 % de la production en raison des contreperformances des industries alimentaires et de tabac (-6,5 %) et pétrolières, chimiques et plastiques (-14,6 %). Comparativement au premier trimestre 2019, une augmentation de 8,0 % est observée grâce à de meilleures performances. Au deuxième trimestre 2020, une amélioration de 3,3 % de la production est enregistrée, motivée par les gains dans les secteurs énergétiques (+20,7 %) et métalliques. En glissement annuel, l’indice montre une progression de 6,1 %, principalement portée par les industries énergétiques et métalliques.",
      "date": "2020-08-01"
  },
  {
      "title": "Indice harmonisé de la production industrielle définitif du troisième trimestre et provisoire du quatrième trimestre 2019",
      "link": "/documents/IndicesIHPI/Rapport-IHPI-t3-définitif-et-t4-provisoire-2019.pdf",
      "image": "assets/indicesIHPI/IHPI2024.PNG",
      "description": "Un accroissement de 29,1 % de la production industrielle en variation trimestrielle, résultant des hausses de production dans presque toutes les branches d’activité, sauf pour les secteurs pétroliers, chimiques, du caoutchouc et du plastique, ainsi que l’électricité, gaz et eau où des baisses de 10,8 % et 1,0 % ont été observées. En glissement annuel, la production a également augmenté de 4,9 %, principalement grâce à une hausse de 10,9 % pour l’industrie énergétique, 7,1 % pour les industries alimentaires et de tabac, et 0,6 % pour les industries extractives. Le quatrième trimestre révèle, cependant, une chute de 21,1 % de la production industrielle, principalement due à la diminution des productions des industries métalliques, énergétiques, et alimentaires et de tabac, respectivement de 56,0 %, 25,8 % et 17,3 %. En glissement annuel, une légère augmentation de 0,2 % est observée, tirée par la prépondérance du secteur des produits alimentaires et de tabac.",
      "date": "2020-02-15"
  },
  {
      "title": "Indice harmonisé de la production industrielle définitif du deuxième trimestre et provisoire du troisième trimestre 2019",
      "link": "/documents/IndicesIHPI/rapport-ihpi-t2-df_t3-provisoire-2019.pdf",
      "image": "assets/indicesIHPI/IHPI2024.PNG",
      "description": "Une amélioration de 5,2 % de la production industrielle par rapport au trimestre précédent, bénéficiaire de hausses généralisées dans presque toutes les branches, à l'exception de l'industrie du papier, carton et édition, ainsi que des autres industries de fabrication, qui ont connu des baisses respectives de 45,1 % et 19,1 %. En glissement annuel, une légère baisse de 1,3 % est observée, principalement causée par une chute de 99,0 % pour le papier, carton et édition, 68,4 % pour les industries métalliques, et 51,1 % pour les autres industries de fabrication. Considéré au troisième trimestre, cet indice révèle un accroissement de 26,8 % en variation trimestrielle, soutenu par les progrès dans presque toutes les branches.",
      "date": "2019-08-19"
  },
  {
      "title": "Indice harmonisé de la production industrielle définitif du premier trimestre et provisoire du deuxième trimestre 2019",
      "link": "/documents/IndicesIHPI/rapport-ihpi-t1-df_t2-2019-provisoire-_1.pdf_",
      "image": "assets/indicesIHPI/IHPI2024.PNG",
      "description": "Une baisse de 9,6 % de la production industrielle, due aux mauvaises performances des autres industries de fabrication, y compris les métalliques, papiers, et alimentaires. En glissement annuel, la production a également chuté de 4,3 %. Au deuxième trimestre, une amélioration de 7,8 % de la production est observée, malgré la chute des autres industries de fabrication de 19,1 %. En glissement annuel, bien que l'indice affiche une légère baisse de 1,6 %, les secteurs métalliques, autres industries de fabrication, et alimentaires ont connu des chutes significatives.",
      "date": "2019-08-15"
  },
  {
      "title": "Indice harmonisé de la production industrielle définitif du quatrième trimestre 2018 et provisoire du premier trimestre 2019",
      "link": "/documents/IndicesIHPI/rapport-ihpi-t4-2018-df_t1-2019-provisoire_15052019-avec-les-commentaires.pdf",
      "image": "assets/indicesIHPI/IHPI2024.PNG",
      "description": "Une dégradation de 15,3 % de la production industrielle, imputable aux contreperformances enregistrées dans les secteurs alimentaires, métalliques, et de fabrication. En glissement annuel, la production a baissé de 4,2 %. Au premier trimestre 2019, la production continue de décroître avec une baisse de 6,8 % par rapport au trimestre précédent, toujours due à la chute dans les secteurs pétroliers, chimiques, métalliques, et alimentaires.",
      "date": "2019-05-15"
  },
  {
      "title": "Indice harmonisé de la production industrielle définitif du troisième trimestre et provisoire du quatrième trimestre 2018",
      "link": "/documents/IndicesIHPI/rapport_-ihpi_t4-provisoire-_2018_12022019.pdf",
      "image": "assets/indicesIHPI/IHPI2024.PNG",
      "description": "Une hausse de 19,4 % de la production industrielle par rapport au trimestre précédent, grâce aux améliorations notables dans les industries du papier, alimentaire, et pétrolières. En glissement annuel, la production a légèrement chuté de 0,8 %. Pour le quatrième trimestre, une baisse de 9,5 % est constatée, causée principalement par la forte chute de la production alimentaire et de tabac. Néanmoins, la production a progressé de 2,3 % sur un an grâce aux performances positives des industries pétrolières et des services publics.",
      "date": "2019-02-15"
  },
];


const theme = createTheme({
  palette: {
    primary: {
      main: '#388E3C',
    },
    background: {
      default: '#f5f5f5',
    },
  },
});

const StyledSelect = styled(Select)(({ theme }) => ({
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.light,
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.dark,
  },
}));

const IndicesHarmonisesProductionIndustrielle = () => {
  const [visibleCount, setVisibleCount] = useState(4);
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredIHPI, setFilteredIHPI] = useState(ihpiData);
  const navigate = useNavigate(); 

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 2);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
    
    let filtered = ihpiData;

    if (year !== 'Tous') {
      filtered = ihpiData.filter((indice) => {
        const indiceYear = new Date(indice.date).getFullYear();
        return indiceYear === parseInt(year);
      });
    }

    filtered.sort((a, b) => new Date(a.date) - new Date(b.date));
    setFilteredIHPI(filtered);
  };

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />
        <br />
        <br />
   
        <Container maxWidth="lg" style={{ paddingTop: '24px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: '16px' }}>
            Indices Harmonisés de la Production Industrielle (IHPI)
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
               L’évolution de l’activité industrielle à travers l’Indice Harmonisé de la Production Industrielle (IHPI) est élaborée selon la méthodologie commune adoptée par les États membres d’AFRISTAT. L'IHPI est un indicateur clé pour mesurer la dynamique de la production trimestrielle des unités industrielles opérant sur le territoire national.<br /> Avec une base de 100 en 2007, l'IHPI couvre un large éventail de secteurs, notamment les industries extractives, alimentaires, chimiques, textile, cuir, bois, papier, carton, ainsi que les industries mécaniques, de l’énergie, de matériaux de construction, et d'autres industries manufacturières.
          </Typography>
          
          <FormControl fullWidth variant="outlined" style={{ marginLeft: '0px', width: '300px' }}>
  <InputLabel id="year-select-label"> Filtrer par année de publication</InputLabel>
  <StyledSelect
    labelId="year-select-label"
    id="year-select"
    value={selectedYear}
    onChange={handleYearChange}
    label=" Filtrer par année de publication"
  >
    <MenuItem value="Tous">Tous les indices</MenuItem>
    {[...new Set(ihpiData.map((indice) => new Date(indice.date).getFullYear()))]
      .sort((a, b) => b - a) 
      .map((year) => (
        <MenuItem key={year} value={year.toString()}>
          {year}
        </MenuItem>
      ))}
  </StyledSelect>
</FormControl>
          
          <Grid container spacing={1} style={{ marginTop: '10px' }}>
            {filteredIHPI.slice(0, visibleCount).map((indice, index) => (
              <Grid item xs={12} sm={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <Box sx={{ display: 'flex' }}>
                    <a
                      href={indice.link}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <CardMedia
                        component="img"
                        sx={{ width: 91, height: 140, m: 2 }}
                        image={indice.image}
                        alt={indice.title}
                      />
                    </a>
                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                      <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main }}>
                        <a
                          href={indice.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                          {<DownloadIcon />}{indice.title}
                        </a>
                      </Typography>
                      <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                        {indice.description}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Publié en {moment(indice.date).format('MMMM YYYY')}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>

          <Box display="flex" justifyContent="space-between" alignItems="center" style={{ marginTop: '20px' }}>
            {visibleCount < filteredIHPI.length && (
              <Button
                onClick={handleShowMore}
                variant="contained"
                style={{
                  marginTop: '5px',
                  backgroundColor: theme.palette.primary.main,
                  color: 'white',
                  marginBottom: '10px',
                }}
              >
                Plus d'Indices
              </Button>
            )}
          </Box>
            <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px', lineHeight: 1.6 }}>
                      <strong>Note :</strong> Les  Indices Harmonisés de la Production Industrielle (IHPI) sont publiés trimestriellement, généralement <strong>45 jours</strong> après la fin de chaque trimestre, ce qui correspond aux dates suivantes :
                      <ul style={{ listStyleType: 'circle', margin: '10px 0 10px 20px', padding: 0 }}>
                        <li><strong>15 février</strong> - Fin du quatrième trimestre </li>
                        <li><strong>15 mai</strong> - Fin du premier trimestre </li>
                        <li><strong>15 août</strong> - Fin du deuxième trimestre </li>
                        <li><strong>15 novembre</strong> - Fin du troisième trimestre</li>
                      </ul>
                    </Typography>
          

          <Box display="flex" justifyContent="flex-start" alignItems="center">
            <Button
              onClick={() => navigate('/indice')}
              style={{
                marginTop: '5px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              <ArrowBackIcon style={{ marginRight: '8px' }} />
              Retour à la page des indices
            </Button>
          </Box>

        </Container>
        <br />
        <br />
        <Footer />

      </div>
    </ThemeProvider>
  );
}

export default IndicesHarmonisesProductionIndustrielle;